import { Star } from 'lucide-react';
import { FORMULARIO_GLOBAL_QUESTION_TYPES } from 'src/componentes/formulario-global/FormularioGlobalQuestionTypes';
import PerguntaMetadados from './PerguntaMetadados';
import { getOptionColorClassName, toNumber } from './utils';

const getStarCount = (opcao) => {
  const quantidade = [opcao.valor, opcao.texto, opcao.ordem]
    .map(Number)
    .find((valor) => Number.isFinite(valor) && valor > 0);

  return Math.min(5, Math.round(quantidade || 1));
};

function OpcaoLabel({ opcao, tipoPergunta }) {
  if (tipoPergunta !== FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS) {
    return opcao.texto;
  }

  const quantidadeEstrelas = getStarCount(opcao);

  return (
    <span
      aria-label={`${quantidadeEstrelas}/5`}
      className="tw:inline-flex tw:items-center tw:gap-0.5 tw:text-[#f2b01e]"
    >
      {Array.from({ length: quantidadeEstrelas }, (_, index) => (
        <Star aria-hidden="true" fill="currentColor" key={index} size={17} />
      ))}
    </span>
  );
}

function ListaOpcoes({ exibirCores, intl, opcoes, pergunta, tipoPergunta }) {
  return (
    <div
      className={`tw:flex tw:flex-col tw:gap-3.5 ${
        exibirCores ? 'tw:min-w-0 tw:p-0' : 'tw:px-5.5 tw:pt-3.5 tw:pb-5'
      }`}
    >
      <PerguntaMetadados intl={intl} pergunta={pergunta} />
      {opcoes.map((opcao, index) => {
        const quantidade = toNumber(opcao.quantidade);
        const percentual = toNumber(opcao.percentual);
        const percentualFormatado = intl.formatNumber(percentual, {
          maximumFractionDigits: 2,
        });
        const corOpcaoClassName = getOptionColorClassName(opcao, index);

        return (
          <div key={opcao.opcaoId}>
            <div className="tw:mb-1.5 tw:flex tw:items-baseline tw:justify-between tw:gap-3">
              <span className="tw:inline-flex tw:items-center tw:gap-2 tw:text-[13px] tw:text-[#344054] tw:wrap-anywhere">
                {exibirCores && (
                  <span
                    aria-hidden="true"
                    className={`tw:size-2.5 tw:shrink-0 tw:rounded-full tw:bg-current ${corOpcaoClassName}`}
                  />
                )}
                <OpcaoLabel opcao={opcao} tipoPergunta={tipoPergunta} />
              </span>
              <span className="tw:shrink-0 tw:text-xs tw:whitespace-nowrap tw:text-[#667085] tw:[&_strong]:font-bold tw:[&_strong]:text-[#344054]">
                <strong>{percentualFormatado}%</strong> · {quantidade}{' '}
                {intl.formatMessage({ id: 'labelRespostas' })}
              </span>
            </div>
            <progress
              aria-label={`${opcao.texto}: ${percentualFormatado}%`}
              className={`tw:block tw:h-2 tw:w-full tw:appearance-none tw:overflow-hidden tw:rounded-full tw:border-0 tw:bg-[#eef2f6] tw:[&::-webkit-progress-bar]:rounded-full tw:[&::-webkit-progress-bar]:bg-[#eef2f6] tw:[&::-webkit-progress-value]:rounded-full tw:[&::-webkit-progress-value]:bg-current tw:[&::-moz-progress-bar]:rounded-full tw:[&::-moz-progress-bar]:bg-current ${
                exibirCores ? corOpcaoClassName : 'tw:text-[#1d7789]'
              }`}
              max={100}
              value={Math.min(100, Math.max(0, percentual))}
            />
          </div>
        );
      })}
    </div>
  );
}

export default ListaOpcoes;
